// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/TermsArea/style.css
// module id = 3563
// module chunks = 29